export default {
  Billing: {
    TRIAL_NOTICE: [
      'Today is the last day of your trial.',
      'Your trial runs out in {{count}} days.',
    ],
    TRIAL_ENDED_NOTICE: 'Your trial has expired.',
    TRIAL_BUTTON: 'Upgrade now',
    TRIAL_PAST_DUE_NOTICE: 'Your subscription is past due.',
    TRIAL_PAUSED_NOTICE: 'Your subscription is paused.',
    UPDATE_SUBSCRIPTION: 'Update your subscription details here',
    UPGRADE_CALCS: 'Upgrade to run more than one calculation',
    APPROACHING_LIMIT: [
      'You only have {{count}} transaction remaining for {{month}}.', 
      'You only have {{count}} transactions remaining for {{month}}.', 
    ],
    LIMITED: 'You\'ve used up your monthly transaction allowance.',
    RULE_LIMITED: 'You\'ve used your rule allowance.',
    ANNUAL: 'Annual',
    MONTHLY: 'Monthly',
    Page: {
      TITLE: 'Billing',
      TRIAL_NOTICE: 'Your trial has {{num}} days remaining. Upgrade using one of the options below',
      USAGE: ['Current usage: {{numEntities}} entity', 'Current usage: {{numEntities}} entities'],
      CHOOSE_CURRENCY: 'Choose billing currency:',
      BILLING_FREQUENCY: 'Billing frequency:',
      Plans: {
        PER_MONTH: 'per month',
        PER_YEAR: 'per year',
        USAGE: ['For {{numEntities}} entity', 'For {{numEntities}} entities'],
        BILLED_ANNUAL: 'Billed annually',
        BILLED_MONTHLY: 'Billed monthly',
        SELECT: 'Choose this plan',
        UPGRADE: 'Upgrade to {{plan}}',
        DOWNGRADE: 'Downgrade to {{plan}}',
        CURRENT: 'Current plan',
        CANCEL: 'Cancel subscription',
        UPDATE: 'Update subscription',
        SWITCH: 'Switch to {{frequency}} billing',
        EQUIVALENT: 'Equivalent to {{number}} per month',
      },
      Payments: {
        TITLE: 'Payment History',
        NIL: 'A zero charge is sometimes made when your subscription is updated. If the cost of your subscription has reduced, the difference will be used as credit against the next payment',
      },
    },
    Plans: {
      free: {
        NAME: 'Free',
        DESCRIPTION: 'Spot discrepancies in your intercompany balances',
        Features: {
          1: 'Balancer Transaction Matching',
          TOOLTIP_1: 'Get access to the balancer dashboard and transaction history to help you spot posting asymmetries and calculate FX adjustments',
          2: 'Unlimited Users',
          3: 'Unlimited Support',
        },
      },
      lite: {
        NAME: 'Lite',
        DESCRIPTION: 'For businesses with few intercompany transactions or who only need Balancer.',
        Features: {
          1: '**{{count}}** Recharger or BRAG Transactions /mo',
          TOOLTIP_1: 'These can be used to either reconcile bank transactions across the group using BRAG, or to post intercompany recharges through Recharger. A combination of Recharger & BRAG transactions can be used.',
          2: 'All Balancer Features',
          3: 'Unlimited Users',
          4: 'Unlimited Support',
        },
      },
      full: {
        NAME: 'Full',
        DESCRIPTION: 'For businesses with material intercompany transactions.',
        Features: {
          1: '**Unlimited** Recharger Transactions',
          2: '**Unlimited** BRAG Transactions',
          3: 'All Balancer Features',
          4: 'Unlimited Users',
          5: 'Unlimited Support',
        },
      },
      old: {
        Features: {
          1: 'Unlimited entities',
          2: 'Unlimited calculations',
          3: 'Unlimited teammates',
          4: 'Unlimited support',
        },
      },
      202310: {
        lite: {
          Features: {
            1: '**{{count}}** BRAG Transactions /mo',
            TOOLTIP_1: 'These can be used to reconcile bank transactions across the group using BRAG.',
            2: '**3** Recharge Rules',
            3: 'All Balancer Features',
            4: 'Unlimited Users',
            5: 'Unlimited Support',
          },
        },
        full: {
          Features: {
            1: '**Unlimited** Recharge rules',
          },
        },
      },
    },
    Notices: {
      PlanUpdated: {
        TITLE: 'Thanks!',
        BODY: 'We\'ve moved you from the {{oldPlan}} plan to {{newPlan}}, with {{newFreq}} billing. You should receive a receipt for the transaction in the next few minutes.',
      },
      CycleUpdated: {
        TITLE: 'Thanks!',
        BODY: 'We\'ve moved you from {{oldFreq}} billing to {{newFreq}}. You should receive a receipt for the transaction in the next few minutes.',
      },
    },
  },
};
